import * as React from 'react';
import {
    BooleanField,
    BooleanInput,
    Create,
    Datagrid,
    Edit,
    EditButton,
    FunctionField,
    List,
    required,
    SimpleForm,
    TextField,
    TextInput,
    useRecordContext,
    useRedirect,
} from 'react-admin';
import {
    Box,
    Button,
    Divider,
    Typography,
} from '@material-ui/core';
import AdminPagination from '../AdminPagination';

const catalogFilters = [
    <TextInput source="all" label="Rechercher" alwaysOn />,
];

const CatalogTitle = (props: any) => {
    const record = useRecordContext(props);
    return <span>{record?.name || 'Catalogue'}</span>;
};

const CatalogSongsManager = () => {
    const record: any = useRecordContext();
    const redirect = useRedirect();

    if (!record?.id) return null;

    return (
        <Box mt={4}>
            <Divider />

            <Box mt={3} mb={2}>
                <Typography variant="h6">
                    Playlist Catalogue
                </Typography>

                <Typography
                    variant="body2"
                    color="textSecondary"
                >
                    Gérez cette playlist depuis la bibliothèque Karaoké complète :
                    mêmes chansons, recherche, tri et pagination que dans le menu Karaoké.
                </Typography>
            </Box>

            <Button
                variant="contained"
                color="primary"
                onClick={() =>
                    redirect(`/catalog/${record.id}/songs`)
                }
            >
                Ouvrir la bibliothèque Karaoké
            </Button>
        </Box>
    );
};

export const CatalogList = (props: any) => (
    <List
        {...props}
        filters={catalogFilters}
        bulkActionButtons={false}
        sort={{ field: 'name', order: 'ASC' }}
        perPage={50}
        pagination={<AdminPagination />}
        exporter={false}
    >
        <Datagrid>
            <TextField source="name" label="Catalogue" />
            <TextField source="slug" label="Identifiant" />
            <BooleanField source="active" label="Actif" />
            <FunctionField
                label="Type"
                render={(record: any) =>
                    record?.slug === 'general'
                        ? 'Système'
                        : 'Personnalisé'
                }
            />
            <EditButton />
        </Datagrid>
    </List>
);

export const CatalogCreate = (props: any) => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <TextInput
                source="name"
                label="Nom du catalogue"
                validate={required()}
                fullWidth
            />
            <TextInput
                source="slug"
                label="Identifiant"
                validate={required()}
                fullWidth
            />
            <BooleanInput
                source="active"
                label="Actif"
                defaultValue={true}
            />
        </SimpleForm>
    </Create>
);

export const CatalogEdit = (props: any) => (
    <Edit
        {...props}
        mutationMode="pessimistic"
        title={<CatalogTitle />}
    >
        <SimpleForm redirect={false}>
            <TextInput
                source="name"
                label="Nom du catalogue"
                validate={required()}
                fullWidth
            />
            <TextInput
                source="slug"
                label="Identifiant"
                validate={required()}
                fullWidth
            />
            <BooleanInput source="active" label="Actif" />
            <CatalogSongsManager />
        </SimpleForm>
    </Edit>
);
